<payee-chip-dropdown
  [placeholder]="'CASES_TABLE.FILTERS.PRODUCT.LABEL' | translate"
  [displayWith]="displayWith"
  [selected]="product"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="clearFilter()"
>
  <payee-dropdown
    width="normal"
    [formControl]="productControl"
    [options]="productOptions"
    [displayWith]="displayWith"
    [placeholder]="'CASES_TABLE.FILTERS.PRODUCT.PLACEHOLDER' | translate"
  ></payee-dropdown>
  <button
    payee-button
    color="primary"
    class="top-margin-10"
    width="normal"
    (click)="applyFilter()"
  >
    {{ "CASES_TABLE.FILTERS.APPLY" | translate }}
  </button>
</payee-chip-dropdown>
